(() => {
  if (!['halloween','thanksgiving','christmas','newyear','valentines','stpatricks'].includes(document.documentElement.dataset.seasonalTheme)) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = localStorage.getItem('illegal-seasonal-motion-paused') === 'true'; } catch (_) {}
  const visible = new Set();
  const update = () => {
    document.documentElement.dataset.seasonalPaused = String(paused);
    visible.forEach(el => el.classList.toggle('seasonal-in-view', !document.hidden && !reduced.matches && !paused));
    document.querySelectorAll('.seasonal-motion-toggle').forEach(toggle => {
      toggle.hidden = reduced.matches;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.textContent = paused ? toggle.dataset.seasonalResume : toggle.dataset.seasonalPause;
    });
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('.seasonal-motion-toggle')) return;
    paused = !paused;
    try { localStorage.setItem('illegal-seasonal-motion-paused', String(paused)); } catch (_) {}
    update();
  });
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) visible.add(target);
      else { visible.delete(target); target.classList.remove('seasonal-in-view'); }
    });
    update();
  });
  const observe = root => root.querySelectorAll('[data-seasonal-motion]').forEach(el => observer.observe(el));
  observe(document);
  document.addEventListener('visibilitychange', update);
  reduced.addEventListener('change', update);
  document.addEventListener('shopify:section:load', event => observe(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-seasonal-motion]').forEach(el => { observer.unobserve(el); visible.delete(el); });
  });
})();
